import { ActionContext } from 'vuex'
import apiAuth from '@/api/auth'
import util from '@/utils/classToObject'
import actionsTypes from '@/store/all-action-types'
import types from './all-mutation-types'
import { IRootState, emptyAction, actionEnsure, payloadAction } from '@/store'
import { IAuthState } from './state'
import { AloUserIdentity } from '@/models/alo/AloUserIdentity'
import { AloError } from '@/models/alo/AloError'
import { AloIdentity } from '@/models/alo/AloIdentity'
import { ApiResultCode } from '@/enum/ApiResultCode'
import api from '@/utils/api'
import { AloForgottenPass } from '@/models/alo/AloForgottenPass'
import { AloUser } from '@/models/alo/AloUser'

export class AuthAction {
  public [types.AUTH_REQUEST](context: ActionContext<IAuthState, IRootState>, identity: AloUserIdentity) {
    return new Promise((resolve, reject) => {
      context.commit(types.AUTH_REQUEST)
      apiAuth
        .authenticate(identity)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {            

            const user = resp.data.data as AloUser            
            context.commit(types.AUTH_SUCCESS)
            context.commit(types.AUTH_USER_SUCCESS, user)                                      
            resolve(resp.data.data)
          } else {
            context.dispatch(types.AUTH_AUTO_LOGOUT_REQUEST)
            context.commit(types.AUTH_ERROR)
            reject((resp.data.data as AloError).errorMessage)
          }
        })
        .catch(err => {
          context.dispatch(types.AUTH_AUTO_LOGOUT_REQUEST)
          context.commit(types.AUTH_ERROR)
          reject(err)
        })
    })
  }

  public [types.AUTH_AUTOLOG_REQUEST](context: ActionContext<IAuthState, IRootState>,key:string) {
    return new Promise((resolve, reject) => {
      context.commit(types.AUTH_AUTOLOG_REQUEST)
      apiAuth
        .autolog(key)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {            

            const user = resp.data.data as AloUser            
            context.commit(types.AUTH_SUCCESS)
            context.commit(types.AUTH_USER_SUCCESS, user)                                      
            resolve(resp.data.data)
          } else {
            context.dispatch(types.AUTH_AUTO_LOGOUT_REQUEST)
            context.commit(types.AUTH_ERROR)
            reject((resp.data.data as AloError).errorMessage)
          }
        })
        .catch(err => {
          context.dispatch(types.AUTH_AUTO_LOGOUT_REQUEST)
          context.commit(types.AUTH_ERROR)
          reject(err)
        })
    })
  }

  public [types.AUTH_AUTO_LOGOUT_REQUEST](context: ActionContext<IAuthState, IRootState>) {
    return emptyAction(context,types.AUTH_LOGOUT_REQUEST,types.AUTH_LOGOUT_SUCCESS,types.AUTH_LOGOUT_ERROR,apiAuth.logout)    
  }

  public [types.AUTH_LOGOUT_REQUEST](context: ActionContext<IAuthState, IRootState>) {
      context.commit(types.AUTH_SET_REDIRECT_PATH,"/")
      return emptyAction(context,types.AUTH_LOGOUT_REQUEST,types.AUTH_LOGOUT_SUCCESS,types.AUTH_LOGOUT_ERROR,apiAuth.logout)    
  }

  public [types.AUTH_PASSWORD_REQUEST](context: ActionContext<IAuthState, IRootState>, data: AloForgottenPass) {
    return payloadAction(context,types.AUTH_PASSWORD_REQUEST,types.AUTH_PASSWORD_SUCCESS,types.AUTH_PASSWORD_ERROR,apiAuth.forgetPassword,data)    
  }

  public [types.AUTH_CHANGE_PASSWORD_REQUEST](context: ActionContext<IAuthState, IRootState>, data: AloForgottenPass) {
    return payloadAction(context,types.AUTH_CHANGE_PASSWORD_REQUEST,types.AUTH_CHANGE_PASSWORD_SUCCESS,types.AUTH_CHANGE_PASSWORD_ERROR,apiAuth.changePassword,data)    
  }

  public [types.AUTH_CREATE_PASSWORD_REQUEST](context: ActionContext<IAuthState, IRootState>, data: AloForgottenPass) {
    return payloadAction(context,types.AUTH_CREATE_PASSWORD_REQUEST,types.AUTH_CREATE_PASSWORD_SUCCESS,types.AUTH_CREATE_PASSWORD_ERROR,apiAuth.createPassword,data)    
  }


  public [types.AUTH_USER_REQUEST](context: ActionContext<IAuthState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.AUTH_USER_REQUEST)
      apiAuth
        .getAuthenticatedUser()
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            const identity = resp.data.data as AloUser            
            context.commit(types.AUTH_USER_SUCCESS, identity)            
            resolve(resp.data.data)
          } else {
            context.commit(types.AUTH_USER_ERROR)
            context.dispatch(types.AUTH_AUTO_LOGOUT_REQUEST)
            reject((resp.data.data as AloError).errorMessage)
          }
        })
        .catch(err => {          
          context.commit(types.AUTH_USER_ERROR)
          context.dispatch(types.AUTH_AUTO_LOGOUT_REQUEST)
          reject(err)
        })
    })
  }
  

  public [types.AUTH_RESET_STATUS](context: ActionContext<IAuthState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.AUTH_RESET_STATUS)
      resolve()
    })
  }
  
  public [types.AUTH_SET_REDIRECT_PATH](context: ActionContext<IAuthState, IRootState>,path:string)  {
    return new Promise((resolve, reject) => {
        context.commit(types.AUTH_SET_REDIRECT_PATH,path)
        resolve()
    })
  }

}

export default util.classToObject(AuthAction)
